import { SapOdpDataset } from 'app/model/dataset/sap-odp.dataset';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { SapCdcLinkedService } from 'app/model/linkedservice/sap-cdc.linkedservice';

/**
 * @deprecated
 */
@Metamodel.model({
    name: adfModelTypeMap.sapCdc.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorLegacyNameByFlag(stringResources.SapOdp_DisplayText, !__IS_FABRIC_DPE__)),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorLegacyNameByFlag(stringResources.SapOdp_DisplayText, !__IS_FABRIC_DPE__))
    ],
    constraints: {
        linkedService: {
            model: SapCdcLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapCdcDataset extends SapOdpDataset {}
